// extracted by mini-css-extract-plugin
export default {"c":"flip-card_c__usWHV","front":"flip-card_front__N5Jp6","back":"flip-card_back__iyVyR","container":"flip-card_container__Ec5S5"};